import { EndOfJourneyScanUploadLimits } from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEndOfJourneyScanUploadLimits() {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-scans'].getUploadLimits.url, null))
    .get<EndOfJourneyScanUploadLimits>()
}
